import angular from 'angular';
import helloBookAttachments from './helloBookAttachments';

export default angular.module('helloBook.components', [helloBookAttachments])
  .name;
